import { naturalLanguageFormat } from '@monofront/business/utils';
import { useEffect, useState } from 'react';

export const useRelativeDateTime = (date: string) => {
  const [formattedDate, setFormattedDate] = useState<string>('');

  useEffect(() => {
    const currentDate = new Date();
    const providedDate = new Date(date);
    const timeDifference = currentDate.getTime() - providedDate.getTime();
    const secondsDifference = Math.floor(timeDifference / 1000);
    const minutesDifference = Math.floor(secondsDifference / 60);
    const hoursDifference = Math.floor(minutesDifference / 60);
    const daysDifference = Math.floor(hoursDifference / 24);

    if (secondsDifference < 60) {
      setFormattedDate(`${secondsDifference} seconds ago`);
    } else if (minutesDifference < 60) {
      setFormattedDate(`${minutesDifference} minutes ago`);
    } else if (hoursDifference < 24) {
      setFormattedDate(`${hoursDifference} hours ago`);
    } else if (daysDifference < 7) {
      setFormattedDate(`${daysDifference} days ago`);
    } else {
      setFormattedDate(naturalLanguageFormat(date));
    }
  }, [date]);

  return formattedDate;
};
